// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1478":"bc735c221367dbce","2036":"1cf0157af5fa9701","2171":"05a22bda6c4283dd","2739":"49faf4e05093176d","5133":"29fb5606e8bda083"}[chunkId] + ".js";
};